export default __webpack_public_path__ + "img/tab1rank-80d2db67.png";